module.exports = __webpack_public_path__ + "static/img/13062B_R_02_20170813_LC.1a06582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13062B_R_02_20170813_LC.png
// module id = NTRz
// module chunks = 0